import { render } from "./SchemeComparisonChart.vue?vue&type=template&id=4a6eaae0&ts=true"
import script from "./SchemeComparisonChart.vue?vue&type=script&lang=ts"
export * from "./SchemeComparisonChart.vue?vue&type=script&lang=ts"

import "./SchemeComparisonChart.vue?vue&type=style&index=0&id=4a6eaae0&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__